import React from "react";
import styled from "styled-components";

const Empty = styled.div`
  align-self:stretch;
  background:#f2f2f2;
  color:#999999;
  font-size: 17px;
  margin-left: -4px;
  margin-top: 8px;
  padding:12px;  
`;
const EmptyCashflows = ({ message }) => (
  <Empty>
    {message || "There is insufficient data to generate cashflows. Please contact your LoanBoss Administrator for assistance."}
  </Empty>
);

export default EmptyCashflows;
